import { useEffect, useState } from 'react';

import siteApi from '@bo-apis/system/siteApi';
import termsApi from '@bo-apis/system/termsApi';

export const useDetailHooks = ({ siteNumber }) => {
  const [subsidiaryList, setSubsidiaryList] = useState([]);
  const [jobGroupList, setJobGroupList] = useState([]);
  const [redirectUrlList, setRedirectUrlList] = useState([]);
  const [applyExceptPayMeanList, setApplyExceptPayMeanList] = useState([]);
  const [welmallInfo, setWelmallInfo] = useState({});
  const [siteMemberCnt, setSiteMemberCnt] = useState({});
  const [siteDisplay, setSiteDisplay] = useState({});
  const [siteBasicInfo, setSiteBasicInfo] = useState({});
  const [siteTermList, setSiteTermList] = useState([]);
  const [form, setForm] = useState({ footerAppDownloadUseYn: 'N' });
  const [audit, setAudit] = useState({});

  const handleRefreshTerm = async () => {
    const { result } = await termsApi.getSiteTermsManagementList(siteNumber);
    setSiteTermList(result);
  };

  const handleRefreshDisplay = async () => {
    const { result } = await siteApi.getSiteDisplay(siteNumber);
    setSiteDisplay(result);
  };

  const handleRefreshSiteInfo = async () => {
    if (siteNumber === process.env.REACT_APP_WELLMALL) {
      const {
        result: { siteManagement: welmallInfo },
      } = await siteApi.getSiteManagement(process.env.REACT_APP_WELLMALL);

      setWelmallInfo(welmallInfo);
    }

    const {
      result: { siteManagement },
    } = await siteApi.getSiteManagement(siteNumber);
    setSiteBasicInfo(siteManagement);
    setAudit({
      createDate: siteManagement.createDate,
      creatorName: siteManagement.creatorName,
      updateDate: siteManagement.updateDate,
      updaterName: siteManagement.updaterName,
    });
    setForm({ footerAppDownloadUseYn: siteManagement.footerAppDownloadUseYn });
  };

  const moveSite = () => {
    window.open(siteBasicInfo.sitePcUrl);
  };

  useEffect(() => {
    const getSite = async () => {
      const [
        { result: siteDisplay },
        { result: memberCnt },
        {
          result: { siteManagement, subsidiaryList, siteInquiryJobGroupList, redirectUrlList, siteApplyExceptPayMeanList },
        },
        {
          result: { siteManagement: welmallInfo },
        },
        { result: siteTermList },
      ] = await Promise.all([
        siteApi.getSiteDisplay(siteNumber),
        siteApi.getSiteMemberCnt(siteNumber),
        siteApi.getSiteManagement(siteNumber),
        siteApi.getSiteManagement(process.env.REACT_APP_WELLMALL),
        termsApi.getSiteTermsManagementList(siteNumber),
      ]);
      setSiteMemberCnt(memberCnt);
      setSiteDisplay(siteDisplay);

      setSiteBasicInfo(siteManagement);
      setSubsidiaryList(subsidiaryList);
      setJobGroupList(siteInquiryJobGroupList);
      setRedirectUrlList(redirectUrlList);
      setApplyExceptPayMeanList(siteApplyExceptPayMeanList);
      setAudit({
        createDate: siteManagement.createDate,
        creatorName: siteManagement.creatorName,
        updateDate: siteManagement.updateDate,
        updaterName: siteManagement.updaterName,
      });
      setWelmallInfo(welmallInfo);
      setSiteTermList(siteTermList);
      setForm({ footerAppDownloadUseYn: siteManagement.footerAppDownloadUseYn || 'N' });
    };
    getSite();
  }, [siteNumber]);

  return {
    welmallInfo,
    redirectUrlList,
    jobGroupList,
    subsidiaryList,
    applyExceptPayMeanList,
    siteMemberCnt,
    siteDisplay,
    siteBasicInfo,
    siteTermList,
    form,
    audit,
    handleRefreshSiteInfo,
    handleRefreshDisplay,
    handleRefreshTerm,
    setSiteMemberCnt,
    setForm,
    moveSite,
  };
};
